module.exports = __webpack_public_path__ + "img/empty-video.57b92e26.svg";